<template>
  <key-value :title="title">
    <span v-if="value">
      <span> 1 {{ getCurrencyName(from) }}</span>
      &#61;&#126;
      <strong>
        {{ value | currency }}
      </strong>
      <span> {{ getCurrencyName(to) }}</span>
    </span>
    <span v-else>
      --
    </span>
  </key-value>
</template>
<script>
export default {
  props: {
    from: { required: true, type: String },
    to: { required: true, type: String },
    title: { required: false, type: String },
    rateKey: { required: true, type: String },
    transaction: { required: true, type: Object },
  },

  methods: {
    getCurrencyName(key) {
      return this.objectValueFromPath(this.transaction, `${key}.short_name`, "N/A");
    },
  },
  computed: {
    value() {
      return this.objectValueFromPath(this.transaction, this.rateKey);
    },
  },
};
</script>
